import { Dialog, mergeStyles, MessageBar, MessageBarButton, MessageBarType, Stack, Text } from '@fluentui/react';
import { createSelector } from '@reduxjs/toolkit';
import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { io } from 'socket.io-client';

import { RootState, useAppSelector } from '../../../App/store';
import { actions, useFormSelector } from '../slice';
import LeftTab from './Components/LeftTab';
import PageSelector from './Components/PageSelector';
import PinSection from './Components/PinSection';
import RightTab from './Components/RightTab';

const MobileLayout = () => {
  const [isLocked, setLocked] = useState<boolean>(false);

  useEffect(() => {
    const listener = () => {
      setLocked(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", listener);

    return () => window.removeEventListener("resize", listener);
  }, []);

  if (isLocked) {
    return (
      <MessageBar messageBarType={MessageBarType.warning}>
        Dikey ekranda form yazılamaz
      </MessageBar>
    );
  } else {
    return (
      <Stack tokens={{ childrenGap: 15 }}>
        <RightTab horizontal />
        <LeftTab />
      </Stack>
    );
  }
};

const ComputerLayout = () => (
  <Stack horizontal tokens={{ childrenGap: 15 }}>
    <div style={{ width: "20%" }}>
      <RightTab />
    </div>
    <div style={{ width: "80%" }}>
      <LeftTab />
    </div>
  </Stack>
);

export default () => {
  const newFormsCount = useSelector(sel);
  const currentEditorWinId = useSelector(sel2);
  const employee = useFormSelector((state) => state?.employee);
  const wsUrl = useAppSelector((state) => state.auth.userdata?.wsUrl);
  const [wsConnected, setWsConnected] = useState<boolean>(false);

  const isEditDisabled =
    currentEditorWinId && currentEditorWinId !== window.windowId;

  useEffect(() => {
    if (newFormsCount === 0) {
      actions.createNewForm();
    }
  }, [newFormsCount]);

  useEffect(() => {
    if (!wsUrl) return () => {};

    const socket = io(wsUrl);

    socket.on("connect", () => {
      console.log("ws-connected: forms");
      setWsConnected(true);
    });

    socket.on("disconnect", () => {
      console.log("ws-disconnected: forms");
      setWsConnected(false);
    });

    socket.on(
      "form-data",
      (senderWinId: string, formUUID: string, data: any) => {
        if (senderWinId !== window.windowId) {
          actions.setForm({ uuid: formUUID, data: JSON.parse(data) });
        }
      }
    );

    return () => socket.disconnect();
  }, [wsUrl]);

  if (newFormsCount === 0) {
    return <>Initializing forms...</>;
  }

  return (
    <div className={containerStyles}>
      {wsUrl && !wsConnected && (
        <MessageBar messageBarType={MessageBarType.severeWarning}>
          WS bağlantısı yok, mağazadaki diğer cihazların canlı form bilgisi bu
          cihaza kopyalanmayacaktır.
        </MessageBar>
      )}
      <Stack tokens={{ childrenGap: 5 }}>
        <Stack horizontal tokens={{ childrenGap: 15 }}>
          <Text variant="xxLarge">Yeni Form</Text>
          <PageSelector />
        </Stack>
        {isEditDisabled && (
          <MessageBar
            messageBarType={MessageBarType.warning}
            isMultiline={false}
            actions={
              <MessageBarButton
                onClick={() =>
                  actions.setFormVariable(["editorWindowId", window.windowId])
                }
              >
                Formu bu cihaza aktar
              </MessageBarButton>
            }
          >
            Bu form başka cihazda aktif, sadece o cihazda düzenleme yapılabilir.
          </MessageBar>
        )}
        <div style={isEditDisabled ? { pointerEvents: "none" } : undefined}>
          {!employee?.id && (
            <Dialog hidden={false} dialogContentProps={{ title: "PIN" }}>
              <PinSection />
            </Dialog>
          )}

          {isMobile || window.innerWidth < 1200 ? (
            <MobileLayout />
          ) : (
            <ComputerLayout />
          )}
        </div>
      </Stack>
      <br />
    </div>
  );
};

const sel = createSelector(
  (state: RootState) => state.currentForm.newForms,
  (newForms) => Object.keys(newForms).length
);
const sel2 = createSelector(
  (state: RootState) => state.currentForm,
  (current) => current.newForms[current.editingNewFormUUID]?.editorWindowId
);
const containerStyles = mergeStyles({
  width: "95%",
  minWidth: "500px!important",
  maxWidth: "100%!important",
  marginTop: "12px",
  marginLeft: "50%",
  transform: "translateX(-50%)",
});
